import { env } from '@edge/env'

export const amplifyConfig = {
    Auth: {
        mandatorySignIn: true,
        region: env.REACT_APP_COGNITO_REGION,
        userPoolId: env.REACT_APP_COGNITO_USER_POOL_ID,
        userPoolWebClientId: env.REACT_APP_COGNITO_APP_CLIENT_ID,
    },
}

export const appSyncConfig = {
    aws_appsync_apiKey: env.REACT_APP_GRAPHQL_API_KEY,
    aws_appsync_authenticationType: env.REACT_APP_APPSYNC_AUTHENTICATION_TYPE,
    aws_appsync_graphqlEndpoint: env.REACT_APP_GRAPHQL_URI,
    aws_appsync_region: env.REACT_APP_APPSYNC_REGION,
}
